import React from "react";
import { ReactP5Wrapper } from "react-p5-wrapper";  // im using "react-p5-wrapper": "^3.0.2", do not remove this comment

function grid(p) {
    const GRID_COLOR = [200, 200, 200, 80];
    p.push();
    p.stroke(...GRID_COLOR);
    p.strokeWeight(1);
    let step = 40;
    let gridSize = 2000;
    for (let x = -gridSize; x <= gridSize; x += step) {
        p.line(x, -gridSize, x, gridSize);
    }
    for (let y = -gridSize; y <= gridSize; y += step) {
        p.line(-gridSize, y, gridSize, y);
    }
    p.pop();
}

const Communication = ({ p5ref, wt, ht, scale, fs, bgcolor }) => {

    const sketch = (p) => {
        // --- Color definitions ---
        const DEEP_BLACK = [15, 15, 15];
        const PINK = [235, 93, 123];
        const BLUE = [93, 105, 235];
        const BEIGE = [255, 254, 246];

        // let firstText = `A relationship doesn't unravel all at once,`
        // let secondText = 'it holds together in the quiet threads of the everyday.';

        let firstText = "Love is the recursive habit of returning,"
        let secondText = `a loop where every "hello" carries the weight of "forever".`

        let latoFont = 'Lato';
        let feelWidths = [];
        let doWidths = [];
        let spaceKerning = 4.75;

        let points = [];
        let maxPoints = 80;
        let timeVal = 0;
        const FPS = 60;

        let numExtras = 20;
        let extraOffsets = [];

        function loadGoogleFont() {
            const link = document.createElement('link');
            link.href = 'https://fonts.googleapis.com/css2?family=Lato&display=swap';
            link.rel = 'stylesheet';
            document.head.appendChild(link);
        }

        p.setup = () => {
            loadGoogleFont();
            p.createCanvas(wt, ht);
            p.textAlign(p.LEFT, p.CENTER);
            p.textSize(fs);
            p.textFont(latoFont);

            for (let i = 0; i < numExtras; i++) {
                extraOffsets.push({
                    seed: p.random(1000, 50000),
                    yOffset: p.random(-200, 200),
                    amplitude: p.random(60, 150)
                });
            }

            for (let i = 0; i < firstText.length; i++) {
                feelWidths[i] = p.textWidth(firstText[i]) + (firstText[i] === ' ' ? spaceKerning : 0);
            }
            for (let i = 0; i < secondText.length; i++) {
                doWidths[i] = p.textWidth(secondText[i]) + (secondText[i] === ' ' ? spaceKerning : 0);
            }
        };

        const maincontent_old = () => {
            p.push();
            p.translate(p.width / 2 - (maxPoints * 7) / 2, p.height / 2.25);
            // write the code here, please do not remove this comment


            p.pop();
        };



        const maincontent = () => {
            p.push();
            // Center horizontally, and set a base height for the "spawning" zone
            p.translate(p.width / 2, p.height / 2.25);

            if (!p.messageChain) {
                p.messageChain = [];
                const totalInView = 5; // How many bubbles exist in the cycle
                for (let i = 0; i < totalInView; i++) {
                    // Space them out vertically by 100 pixels initially
                    p.messageChain.push(new MessageBubble(i % 2 === 0, i * 100));
                }
            }

            p.messageChain.forEach(msg => {
                msg.update();
                msg.display();
            });
            p.pop();
        };


        class MessageBubble {
            constructor(isBlue, startY) {
                this.isBlue = isBlue;
                this.y = startY;
                this.bw = 180;
                this.bh = 45;
            }

            update() {
                // Constant upward movement for the whole chain
                this.y -= 1.2;

                // reset logic: when a bubble moves too far up, 
                // wrap it back to the bottom of the column
                if (this.y < -250) {
                    this.y = 250;
                    // Optional: swap color on reset to keep the pattern alternating
                    this.isBlue = !this.isBlue;
                }

                // Calculate opacity based on Y position
                // Fades in at the bottom (200 to 100) and out at the top (-100 to -200)
                if (this.y > 100) {
                    this.opacity = p.map(this.y, 250, 100, 0, 0);
                } else if (this.y < -100) {
                    this.opacity = p.map(this.y, -100, -250, 150, 0);
                } else {
                    this.opacity = 150;
                }
            }
            display() {
                p.push();
                const col = this.isBlue ? BLUE : PINK;
                p.fill(col[0], col[1], col[2], this.opacity);
                p.noStroke();

                const x = -this.bw / 2;
                const r = 20; // Corner radius for the "rounded" parts

                // Specify corners: tl, tr, br, bl
                if (this.isBlue) {
                    // Left tail: keep the bottom-left (bl) corner sharp (0)
                    p.rect(x, this.y, this.bw, this.bh, r, r, r, 0);
                } else {
                    // Right tail: keep the bottom-right (br) corner sharp (0)
                    p.rect(x, this.y, this.bw, this.bh, r, r, 0, r);
                }

                // Sharp Tail - perfectly aligned to the sharp corner
                p.beginShape();
                if (this.isBlue) {
                    // Left tail starts at the sharp bottom-left corner
                    p.vertex(x, this.y + this.bh - 15);
                    p.vertex(x - 12, this.y + this.bh);
                    p.vertex(x, this.y + this.bh);
                } else {
                    // Right tail starts at the sharp bottom-right corner
                    p.vertex(x + this.bw, this.y + this.bh - 15);
                    p.vertex(x + this.bw + 12, this.y + this.bh);
                    p.vertex(x + this.bw, this.y + this.bh);
                }
                p.endShape(p.CLOSE);

                p.pop();
            }
        }

        const statictext = () => {
            p.push();
            p.textSize(fs);
            p.textFont(latoFont);
            p.fill(...DEEP_BLACK);

            let firstWidth = feelWidths.reduce((a, b) => a + b, 0);
            let secondWidth = doWidths.reduce((a, b) => a + b, 0);

            let x1 = p.width / 2 - firstWidth / 2;
            for (let i = 0; i < firstText.length; i++) {
                p.text(firstText[i], x1, p.height - 120);
                x1 += feelWidths[i];
            }

            let x2 = p.width / 2 - secondWidth / 2;
            for (let i = 0; i < secondText.length; i++) {
                p.text(secondText[i], x2, p.height - 92);
                x2 += doWidths[i];
            }
            p.pop();
        };

        p.draw = () => {
            p.background(BEIGE);
            grid(p);
            maincontent();
            statictext();
        };
    };

    return (
        <div style={{ backgroundColor: bgcolor }}>
            <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
                <ReactP5Wrapper sketch={sketch} />
            </div>
        </div>
    );
};

export default Communication;